import {FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import TableStatic from 'components/Table/TableStatic';
import {useBackend} from 'state/backend';
import FilenamePreview from '../../common/FilenamePreview';
import PdfFilenameComponentName from '../../common/PdfFilenameComponentName';
import PdfFilenameSectionHeader from '../../common/SectionHeader';
import {
    PdfFilenameElementOption,
    PdfFilenameSectionName,
    PdfFilenameSettingsBackendData,
} from '../../types';

type SectionProps = {
    sectionName: PdfFilenameSectionName;
};

const Section: FC<SectionProps> = ({sectionName}) => {
    const {t} = useTranslation('Document.PdfFilenameSettings');
    const {data} = useBackend<PdfFilenameSettingsBackendData>();

    const elements = data[sectionName] || [];

    const [hoverId, setHoverId] = useState<PdfFilenameElementOption | null>(
        null,
    );

    return (
        <div
            className="mb-4 flex flex-col gap-y-3"
            data-testid={`section:${sectionName}`}
        >
            <PdfFilenameSectionHeader sectionName={sectionName} />
            <div className="flex">
                <FilenamePreview
                    elements={elements}
                    hoverId={hoverId}
                    sectionName={sectionName}
                />
            </div>
            <TableStatic>
                <TableStatic.Header>
                    <TableStatic.HeaderRow>
                        <TableStatic.Column className="w-20">
                            {t('table.order')}
                        </TableStatic.Column>
                        <TableStatic.Column>
                            {t('table.component')}
                        </TableStatic.Column>
                    </TableStatic.HeaderRow>
                </TableStatic.Header>
                <TableStatic.Body>
                    {elements.map((element, index) => (
                        <TableStatic.Row
                            key={element}
                            onMouseOut={() => setHoverId(null)}
                            onMouseOver={() => setHoverId(element)}
                        >
                            <TableStatic.Cell>{index + 1}</TableStatic.Cell>
                            <TableStatic.Cell>
                                <PdfFilenameComponentName element={element} />
                            </TableStatic.Cell>
                        </TableStatic.Row>
                    ))}
                </TableStatic.Body>
            </TableStatic>
        </div>
    );
};

export default Section;
